export const ACCESS_TOKEN_NAME = 'token';
